import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { MenuService } from '@core';
import { IMenu } from '../../models/core/menu';
import { environment } from 'environments/environment';
import { AuthService } from '@shared/auth/auth.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { KeysComponent } from 'app/components/home/keys/keys.component';
import { SharedModule } from '../../shared/shared.module';



@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class SidebarComponent {
  // NOTE: Ripple effect make page flashing on mobile
  @Input() ripple = false;
  @Input() isMobile = false;

  menu$ = this.menu.getAll();
  menuResponse: IMenu[] = [];
  buildRoute = this.menu.buildRoute;
  @Output() toggleCollapsed = new EventEmitter<boolean>();
  @Output() openedChange = new EventEmitter<void>();

  public showLinks: boolean = false;

  private environment = environment;

  constructor(private menu: MenuService, 
    private authService: AuthService,
    private modalService: MatDialog) { }

  ngOnInit() {
    if (this.authService.userRoles.length == 0) {
      this.authService.loadUserInformation();
    }

    //This sets up the namespace required for translating the sidebar options
    this.menu$.subscribe(
      response => {
        if(environment.translateText){
          this.menu.addNamespace(response, 'menu');
        }
      }
    )
  }

  // showLink(auth?: boolean, roles?: string[])  {  
  showLink(auth?: boolean, roles?: string[]) : boolean {

    //Roles required to view link
    if(roles != null && roles.length > 0)
    {
      return this.authService.isAuthorized(roles);
    }

    //No auth required, show the link
    if(auth == null || !auth) return true;

    //Auth required but no roles needed
    return this.authService.isAuthorized();
  }

  keysPopup(){
    let config = new MatDialogConfig<any>();
    config.autoFocus = true;
    config.disableClose = false;
    config.minWidth = 500;
    config.maxHeight = 700;
    config.data = {};
    const dialogRef = this.modalService.open(KeysComponent, config);

    dialogRef.afterClosed().subscribe(
        data => {
      },
        error => console.log('error: ', error),
        () => {}
    );  
  }

  printPage(){
    
    this.toggleCollapsed.emit(false);
    this.timeout();
  }

  timeout() {
    setTimeout(() => {
      window.print();
      this.timeout2();
    }, 1000);
  }
  
  timeout2() {
    setTimeout(() => {
      this.toggleCollapsed.emit(true);
    }, 1000);
  }

}
